import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { hasCreateLabPermission } from '../../permission-utils/lab';
import { canViewLabOverview, canViewReports, checkHOD, checkHOU, hideMultipleMenu } from '../../permission-utils/settings';

const ClinicalLabMenu = () => {
	const staff = useSelector(state => state.user.profile);
	const [isSupervisor, setIsSuperVisor] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{/* {isSupervisor && (
				<li>
					<Link to="/lab/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)} */}
			{(canViewLabOverview(staff) || canViewReports(staff, 'inventory-audit')) && (
				<li>
					<Link to="/lab/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			<li>
				<Link to="/lab">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li>
				<Link to="/lab/discharge-queue">
					<div className="icon-w">
						<div className="icon-feather-log-out" />
					</div>
					<span>Discharge Queue</span>
				</Link>
			</li>
			{hasCreateLabPermission(staff.permissions) && (
				<li>
					<Link to="/lab/new-request">
						<div className="icon-w">
							<div className="os-icon os-icon-plus-circle" />
						</div>
						<span>New Lab Request</span>
					</Link>
				</li>
			)}
			{canViewLabOverview(staff) && (
				<>
					<li>
						<Link to="/lab/categories">
							<div className="icon-w">
								<div className="os-icon os-icon-plus-circle" />
							</div>
							<span>Categories</span>
						</Link>
					</li>
					<li>
						<Link to="/lab/resources">
							<div className="icon-w">
								<div className="os-icon os-icon-plus-circle" />
							</div>
							<span>Resources</span>
						</Link>
					</li>
				</>
			)}
			{!['it-admin'].includes(staff.role.slug) &&
				((isSupervisor && hideMultipleMenu(staff)) || canViewReports(staff, 'inventory-audit')) && (
					<>
						<li className="sub-header">
							<span>REPORTS</span>
						</li>
						<li>
							<Link to="/report/lab">
								<div className="icon-w">
									<div className="os-icon os-icon-layers" />
								</div>
								<span>Lab</span>
							</Link>
						</li>
					</>
				)}
			{/* <li>
				<Link to="/lab/admitted-lab">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Admission Bills</span>
				</Link>
			</li> */}
		</>
	);
};

export default ClinicalLabMenu;
